import store from "../../store/index";
import KanbanRequests from "./KanbanRequests";

/** =========== KANBAN =========== **/

export const createNewKanban = async function() {
  const creatorId = store.state.auth.user._id;
  const response = await KanbanRequests.createNewKanban(creatorId);
  if (response && response.data && response.data.kanban) {
    const kanban = response.data.kanban;
    const kanbanId = kanban._id;
    return kanbanId;
  }
};

export const getKanban = async function(kanbanId) {
  const response = await KanbanRequests.getKanban(kanbanId);
  if (response && response.data && response.data.kanban) {
    const kanban = response.data.kanban;
    return kanban;
  }
};

export const getAllKanbans = async function() {
  const response = await KanbanRequests.getAllKanbans();
  if (response && response.data && response.data.kanbans) {
    const kanbans = response.data.kanbans;
    return kanbans;
  }
};

export const createNewColumn = async function(kanbanId, columnIndex, scopeEnabled) {
  const creatorId = store.state.auth.user._id;
  const response = await KanbanRequests.createNewColumn(kanbanId, columnIndex, creatorId, scopeEnabled);
  if (response && response.data && response.data.column) {
    const column = response.data.column;
    return column;
  }
};

export const createNewCard = async function(kanbanId, cardIndex, columnId, scopeEnabled) {
  const creatorId = store.state.auth.user._id;
  const response = await KanbanRequests.createNewCard(kanbanId, cardIndex, columnId, creatorId, scopeEnabled);
  if (response && response.data && response.data.card) {
    const card = response.data.card;
    return card;
  }
};

export const getKanbanColumnsAndCards = async function(kanbanId) {
  const response = await KanbanRequests.getKanbanColumnsAndCards(kanbanId);
  if (response && response.data && response.data.columns && response.data.cards) {
    const columns = response.data.columns;
    const cards = response.data.cards;
    return { columns, cards };
  }
};

export const updateColumnTitle = async function(columnId, newTitle) {
  const response = await KanbanRequests.updateColumnTitle(columnId, newTitle);
  if (response && response.data && response.data.succes) {
    console.log("@updateColumnTitle: Saving column title successsful.");
  }
};

export const updateKanbanTitle = async function(kanbanId, newTitle) {
  const response = await KanbanRequests.updateKanbanTitle(kanbanId, newTitle);
  if (response && response.data && response.data.succes) {
    console.log("@updateKanbanTitle: Saving Kanban title successsful.");
  }
};

export const updateCardTitle = async function(cardId, newTitle) {
  const response = await KanbanRequests.updateCardTitle(cardId, newTitle);
  if (response && response.data && response.data.succes) {
    console.log("@updateCardTitle: Saving card title successsful.");
  }
};

export const updateCardDescription = async function(cardId, newDescription) {
  const response = await KanbanRequests.updateCardDescription(cardId, newDescription);
  if (response && response.data && response.data.succes) {
    console.log("@updateCardDescription: Saving card description successsful.");
  }
};

export const updateColumnIndexes = async function(kanbanId, columnIndexesData) {
  const response = await KanbanRequests.updateColumnIndexes(kanbanId, columnIndexesData);
  if (response && response.data && response.data.success) {
    console.log("@updateColumnIndexes: Updating column indexes successsful.");
  }
};

export const updateCardLocations = async function(kanbanId, cardLocationsData) {
  const response = await KanbanRequests.updateCardLocations(kanbanId, cardLocationsData);
  if (response && response.data && response.data.success) {
    console.log("@updateCardLocations: Updating card locations data successsful.");
  }
};

export const deleteKanban = async function(kanbanId) {
  const response = await KanbanRequests.deleteKanban(kanbanId);
  if (response && response.data && response.data.success) {
    console.log("@deleteKanban: Deleting Kanban successsful.");
  } else {
    console.log("@deleteKanban: Deleting Kanban failed.");
  }
};

export const deleteCard = async function(cardId) {
  const response = await KanbanRequests.deleteCard(cardId);
  if (response && response.data && response.data.success) {
    console.log("@deleteCard: Deleting card successsful.");
  } else {
    console.log("@deleteCard: Deleting card failed.");
  }
};

export const deleteSelectedColumn = async function(kanbanId, columnId) {
  const response = await KanbanRequests.deleteSelectedColumn(kanbanId, columnId);
  if (response && response.data && response.data.success) {
    console.log("@deleteSelectedColumn: Deleting column successsful.");
  } else {
    console.log("@deleteSelectedColumn: Deleting column failed.");
  }
};

const KanbanHelpers = {
  createNewKanban,
  getAllKanbans,
  getKanban,
  createNewColumn,
  createNewCard,
  getKanbanColumnsAndCards,
  updateColumnTitle,
  updateKanbanTitle,
  updateCardTitle,
  updateCardDescription,
  updateColumnIndexes,
  updateCardLocations,
  deleteKanban,
  deleteCard,
  deleteSelectedColumn,
};

export default KanbanHelpers;
